import FormKycCli from './FormKycCli/FormKycCli'
import FormKycProv from './FormKycProv/FormKycProv'

export const FormKycCliPage = FormKycCli
export const FormKycProvPage = FormKycProv
